<template>
    <div :class="'areas-detail '+ selectArea"  >
       <ul class="btn" @click="$parent.isShowAreas(false)" >

       </ul>
       <!-- <image src="./static/img/futurePark.png" /> -->
    </div>
</template>
<script>
    export default {
		props:{
			selectArea:String
		},
        data(){
            return {}
        },
        mounted(){
			
        },
        methods:{
			handleClose(){
				
			}
        },
        components:{
        }
    }
</script>
<style scoped lang="scss" >
    .bg-image-park{
        background:url('../assets/futurePark.png') no-repeat;
        background-size:100% 100%;
    }
    .bg-image-hall{
        background:url('../assets/ScienceHall.png') no-repeat;
        background-size:100% 100%;
    }
    .areas-detail{
        border: 5px #fff solid;
        // height:400px;
        position:fixed;
        z-index:111;
        // background:#fff;
        width:800px;
        height:389px;
        // left:0;
        // right:0;
        top:0;
        bottom:0;
        margin:auto;
        left:10px;
        border-radius:8px;
        overflow: auto;
        .btn{
            background:url('../assets/close.png');
            width:26px;
            height: 26px;
            position: absolute;
            right:0px;
            top:0px;
            cursor: pointer;
        }
    }
    @media screen and (max-width:800px) {
        .bg-image-park{
        background:url('../assets/futurePark.png') no-repeat;
        background-size:100% 100%;
    }
    .bg-image-hall{
        background:url('../assets/ScienceHall.png') no-repeat;
         background-size:100% 100%;
    }
    .areas-detail{
        left:0;
        right:0;
        width:95%;
        height:31%;
        background-size: 100% 100%;

    }
    }
</style>




// WEBPACK FOOTER //
// src/commonComponents/AreasDetail.vue